import PropTypes from 'prop-types';
import React from 'react';

import CrmNavIcon from './CrmNavIcon';
import CollectionsNavIcon from './CollectionsNavIcon';
import SeriesNavIcon from './SeriesNavIcon';

const NavMenuIcon = ({ xlinkHref }) => {
  if (xlinkHref === '#volunteers') return <CrmNavIcon size={20} />;
  if (xlinkHref === '#series') return <SeriesNavIcon size={20} />;
  if (xlinkHref === '#collections') return <CollectionsNavIcon size={20} />;
  return (
    <svg className="sprite-icon" style={{ width: '20px', height: '20px', minWidth: '20px', marginTop: '-3px' }}>
      <use xlinkHref={xlinkHref} />
    </svg>
  );
};

NavMenuIcon.propTypes = { xlinkHref: PropTypes.string };

export default NavMenuIcon;
